'use client';

import {createContext} from 'react';

export const PopperContext = createContext<{
  open: boolean;
  setOpen: (open: boolean) => void;
}>({
  open: false,
  setOpen: () => {},
});
